import { render } from "./MusicControls.vue?vue&type=template&id=7413bedf&scoped=true"
import script from "./MusicControls.vue?vue&type=script&lang=js"
export * from "./MusicControls.vue?vue&type=script&lang=js"

import "./MusicControls.vue?vue&type=style&index=0&id=7413bedf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7413bedf"]])

export default __exports__